import _objectWithoutProperties from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["type", "layerDef"];

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v38.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import e from "@arcgis/core/Basemap";
import { M as r, L as s } from "./map.js";
import { a as i } from "../enums.js";
var a = {
  esriSLSDash: "dash",
  esriSLSDashDot: "dash-dot",
  esriSLSDashDotDot: "long-dash-dot-dot",
  esriSLSDot: "dot",
  esriSLSLongDash: "long-dash",
  esriSLSLongDashDot: "long-dash-dot",
  esriSLSNull: "none",
  esriSLSShortDash: "short-dash",
  esriSLSShortDashDot: "short-dash-dot",
  esriSLSShortDashDotDot: "short-dash-dot-dot",
  esriSLSShortDot: "short-dot",
  esriSLSSolid: "solid"
},
    t = {
  esriSMSCircle: "circle",
  esriSMSCross: "cross",
  esriSMSDiamond: "diamond",
  esriSMSSquare: "square",
  esriSMSX: "x",
  esriSMSTriangle: "triangle"
},
    o = {
  esriSFSBackwardDiagonal: "backward-diagonal",
  esriSFSCross: "cross",
  esriSFSDiagonalCross: "diagonal-cross",
  esriSFSForwardDiagonal: "forward-diagonal",
  esriSFSHorizontal: "horizontal",
  esriSFSNull: "none",
  esriSFSSolid: "solid",
  esriSFSVertical: "vertical"
},
    l = Object.freeze({
  __proto__: null,
  FieldTypeConversion: {
    esriFieldTypeBlob: "blob",
    esriFieldTypeDate: "date",
    esriFieldTypeDouble: "double",
    esriFieldTypeGeometry: "geometry",
    esriFieldTypeGlobalID: "global-id",
    esriFieldTypeGUID: "guid",
    esriFieldTypeInteger: "integer",
    esriFieldTypeOID: "oid",
    esriFieldTypeRaster: "raster",
    esriFieldTypeSingle: "single",
    esriFieldTypeSmallInteger: "small-integer",
    esriFieldTypeString: "string",
    esriFieldTypeXML: "xml"
  },
  BasemapConversion: {
    "dark-gray": "arcgis-dark-gray",
    gray: "arcgis-light-gray",
    topo: "arcgis-topographic",
    clarityImagery: "clarityImagery",
    reportImagery: "arcgis-imagery",
    streets: "arcgis-streets",
    reportNone: "reportNone",
    osm: "osm-standard"
  },
  LineSymbolStyleConversion: a,
  MarkerSymbolStyleConversion: t,
  FillSymbolStyleConversion: o,
  convertSymbol: function convertSymbol(e) {
    switch (e.type) {
      case "esriSMS":
        e.type = "simple-marker", e.style = t[e.style], e.hasOwnProperty("outline") && (e.outline.type = "simple-line", e.outline.style = a[e.outline.style]);
        break;

      case "esriSFS":
        e.type = "simple-fill", e.style = o[e.style], e.hasOwnProperty("outline") && (e.outline.type = "simple-line", e.outline.style = a[e.outline.style]);
        break;

      case "esriSLS":
        e.type = "simple-line", e.style = a[e.style];
        break;

      case "esriTS":
        e.type = "text", e.font.hasOwnProperty("family") && e.font.family.includes(",") && (e.font.family = e.font.family.split(",")[0]);
        break;

      case "esriPMS":
        e.type = "picture-marker";
    }

    return e;
  },
  toInteger: function toInteger(e) {
    return !0 === e ? 1 : 0;
  }
}),
    n = r.basemaps,
    S = r.customBasemaps,
    y = r.customReportBasemaps,
    d = Object.freeze({
  __proto__: null,
  getBasemapById: function getBasemapById(r) {
    var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

    var t = function (r, a) {
      var t = a ? y : S;

      if (t.hasOwnProperty(r)) {
        var _a = t[r],
            _o = [];
        return _a.baseMapLayers.forEach(function (e) {
          var r = e.type,
              a = e.layerDef,
              t = _objectWithoutProperties(e, _excluded);

          switch (r) {
            case "feature-layer":
              _o.push(s.create(i.FeatureLayer, a || t));

              break;

            case "VectorTile":
              _o.push(s.create(i.VectorTileLayer, a || t));

              break;

            case "WebTiledLayer":
              _o.push(s.create(i.MapImageLayer, a || t));

              break;

            default:
              _o.push(s.create(i.TileLayer, a || t));

          }
        }), new e({
          baseLayers: _o,
          title: _a.title,
          id: r,
          thumbnailUrl: _a.thumbnailUrl
        });
      }
    }(r, a) || e.fromId(r),
        o = n.find(function (e) {
      return e.id === r;
    });

    return o && (t.title = o.title), t;
  },
  basemapIdExists: function basemapIdExists(e) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return (r ? y.hasOwnProperty(e) : S.hasOwnProperty(e)) || void 0 !== n.find(function (r) {
      return r.id === e;
    });
  }
});
export { d as b, l as c };